import { render, staticRenderFns } from "./comp_ProductDataSheet.vue?vue&type=template&id=f585ae86&scoped=true&"
import script from "./comp_ProductDataSheet.vue?vue&type=script&lang=js&"
export * from "./comp_ProductDataSheet.vue?vue&type=script&lang=js&"
import style0 from "./comp_ProductDataSheet.vue?vue&type=style&index=0&id=f585ae86&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f585ae86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VHover,VRow})
